import { get, post } from './request'
import {
  AllSiteResult,
  AllTaskResult,
  AttackType,
  CommonResult,
  CompareComponent,
  CompareFailed,
  CompareScoreRes,
  CompareSuccess,
  ComponentFailed,
  LogFailed,
  OldCommonResult,
  RiskLevel,
  TaskDetailRes,
  TaskSummary,
  TemplateRate,
} from './type'

//**获取所有站点*/
export const getCompareSite = async (): Promise<OldCommonResult<AllSiteResult[]>> =>
  get(`/portal/verify/waf/compare/site`)

// //发送手机验证码
// export const sendCode = (data: any): Promise<CommonResult<string>> =>
//   post(`/api/v1/pub/system/sendCode`, data)

/**获取站点下任务 */
export const getSiteTask = async (site_url: string): Promise<OldCommonResult<AllTaskResult[]>> =>
  get(
    `/portal/verify/waf/compare/result`,
    {
      site_url,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取任务详情 */
export const getTaskDetail = async (result_id: string): Promise<CommonResult<TaskDetailRes>> =>
  get(
    `/portal/verify/waf/compare`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取任务评分 */
export const getCompareScore = async (result_id: string): Promise<CommonResult<CompareScoreRes>> =>
  get(
    `/portal/verify/waf/compare/score`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取获取拦截失败率 */
export const getInterceptFailRate = async (
  result_id: string,
): Promise<OldCommonResult<TemplateRate[]>> =>
  get(
    `/portal/verify/waf/compare/intercept/template`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取攻击类型拦截率 */
export const getAttackIntercept = async (
  result_id: string,
): Promise<OldCommonResult<AttackType[]>> =>
  get(
    `/portal/verify/waf/compare/intercept/attack_type`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取危险等级分布 */
export const getRiskLevel = async (result_id: string): Promise<CommonResult<RiskLevel>> =>
  get(
    `/portal/verify/waf/compare/risk_level`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/** 获取影响组件分布*/
export const getCompareComponent = async (
  result_id: string,
): Promise<CommonResult<CompareComponent<ComponentFailed>>> =>
  get(
    `/portal/verify/waf/compare/component`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取设备告警统计 */
export const getLogDevice = async (
  result_id: string,
): Promise<CommonResult<CompareComponent<LogFailed>>> =>
  get(
    `/portal/verify/waf/compare/log_device`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/**获取任务摘要 */
export const getTaskSummary = async (result_id: string): Promise<CommonResult<TaskSummary>> =>
  get(
    `/portal/verify/waf/compare/interception`,
    {
      result_id,
    },
    {
      timeout: 1000 * 10,
    },
  )

/** 获取拦截失败对比接口*/
export const getCompareFailed = async (
  result_id_first: string,
  result_id_second: string,
): Promise<CommonResult<CompareFailed>> =>
  get(
    `/portal/verify/waf/compare/intercept/failed`,
    {
      result_id_first,
      result_id_second,
    },
    {
      timeout: 1000 * 15,
    },
  )

/**获取拦截成功对比 */
export const getCompareSuccess = async (
  result_id_first: string,
  result_id_second: string,
): Promise<CommonResult<CompareSuccess>> =>
  get(
    `/portal/verify/waf/compare/intercept/success`,
    {
      result_id_first,
      result_id_second,
    },
    {
      timeout: 1000 * 15,
    },
  )
